import React, { Component } from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';
import TextField from '@material-ui/core/TextField';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { colors } from 'helpers/ColorHelper';
import { passwordStrength } from 'helpers/Validator';
import { getTranslatedString } from 'helpers/i18n';

class UpdatePasswordDialog extends Component {
  state = {
    error: null,
    password: '',
    submitting: false,
  };

  updatePassword = password => {
    this.setState({
      error: passwordStrength(password),
      password: password,
    });
  };

  generateRandomPassword = () => {
    const length = Math.floor(Math.random() * (16 - 8 + 1)) + 8;
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&()';
    let newPassword = '';
    for (var i = 0, n = charset.length; i < length; ++i) {
      newPassword += charset.charAt(Math.floor(Math.random() * n));
    }
    this.setState({
      error: null,
      password: newPassword,
    });
  };

  handlePasswordUpdate = () => {
    if (this.props.error) return;
    this.setState({ submitting: true });
    this.props.updatePasswordAction(this.state.password);
    this.setState({ password: '', submitting: false });
  };

  render() {
    const { showDialog, hideDialog, fullScreen } = this.props;

    const disabled = this.state.error || !this.state.password || this.state.submitting;
    return (
      <Dialog
        disableBackdropClick
        fullScreen={fullScreen}
        open={showDialog}
        onRequestClose={hideDialog}
        onClose={this.props.toggleDialog}
        aria-labelledby="confirmation-dialog"
      >
        <DialogTitle>
          <h3 style={{ textAlign: 'center', margin: 0 }}>
            {getTranslatedString('landlordPortal.tenantUpdatePassword.header')}
          </h3>
        </DialogTitle>
        <DialogContent>
          <p style={{ textAlign: 'center' }}>
            {getTranslatedString('landlordPortal.tenantUpdatePassword.description')}
          </p>

          <TextField
            style={{ width: '100%', fontSize: '13px', margin: '10px' }}
            label="New Password"
            value={this.state.password}
            onChange={event => {
              this.updatePassword(event.target.value);
            }}
          />

          <p style={{ color: colors.RED, margin: '10px' }}>{this.state.error}</p>
          <button
            type="button"
            className="link-button"
            style={{ margin: '0 10px' }}
            onClick={() => this.generateRandomPassword()}
          >
            {getTranslatedString('landlordPortal.tenantUpdatePassword.generateRandom')}
          </button>
        </DialogContent>
        <DialogActions style={{ display: 'block', padding: '10px' }}>
          <FlatButton
            onClick={hideDialog}
            id="close-button"
            style={{ color: AccentColor(), textTransform: 'uppercase' }}
          >
            {getTranslatedString('close')}
          </FlatButton>
          <FlatButton
            variant="raised"
            onClick={() => !disabled && this.handlePasswordUpdate()}
            id="submit-button"
            style={{
              color: 'white',
              textTransform: 'uppercase',
              backgroundColor: disabled ? colors.LIGHT_GRAY : AccentColor(),
              paddingLeft: '5px',
              paddingRight: '5px',
            }}
            disabled={disabled}
          >
            {getTranslatedString('landlordPortal.tenantUpdatePassword.updatePassword')}
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withMobileDialog()(UpdatePasswordDialog);
